document.querySelectorAll('.v5-scenario-based-education').forEach((section) => {
    section.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => {
            const section_title =
            window.innerWidth >= 1024
                ? link.closest('.v-blocks-image').querySelector('.blocks-content-heading')?.querySelector('.heading')?.textContent?.trim?.()
                : link.closest('.v-blocks-image').querySelector('.blocks-content-heading')?.querySelector('.mb_heading')?.textContent?.trim?.();
            gaPushDataLayer('user_interaction', {
                module_name: 'Scenario Education',
                section_name: 'v5-场景教育',
                section_title: section_title,
                content_name: '',
                button_name: '',
                element_type: 'content_card',
                interaction_type: 'click',
                interaction_effect: 'page_jump',
                to_url: link.getAttribute('href')
            });
        });
    });

    section.querySelectorAll('jds-button').forEach((button) => {
        button.addEventListener('click', () => {
            const title = button.parentElement.parentElement.parentElement.querySelector('.blocks-content-heading .heading p').textContent;
            gaPushDataLayer('user_interaction', {
            module_name: 'Scenario Education',
            section_name: 'v5-场景教育',
            section_title: title,
            content_name: '',
            button_name: button?.textContent?.trim?.(),
            element_type: 'button',
            interaction_type: 'click',
            interaction_effect: 'page_jump',
            to_url: button.href
                ? window.location.origin + button.href
                : button.closest('.v-blocks-image').querySelector('a').getAttribute('href')
                ? window.location.origin + button.closest('.v-blocks-image').querySelector('a').getAttribute('href')
                : '',
            });
        });
    });
});